import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import LegacyPage from "./pages/LegacyPage";
import PageDirectory from "./pages/PageDirectory";
import GemServicePage from "./pages/GemServicePage";
import LegalMetrologyCompliancePage from "./pages/LegalMetrologyCompliancePage";
import { Toaster } from "./components/ui/toaster";

function App() {
  useEffect(() => {
    // Smooth scroll for anchor links
    document.documentElement.style.scrollBehavior = "smooth";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pages" element={<PageDirectory />} />
          <Route path="/gem-registration" element={<GemServicePage />} />
          <Route path="/legal-metrology-compliance-services" element={<LegalMetrologyCompliancePage />} />
          <Route path="*" element={<LegacyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
